import { Injectable } from '@angular/core'
import { OrderRow, OrderServicesService, OrderServicesTicket } from 'gung-standard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloOrderServicesService extends OrderServicesService {
  public findOrdersContainingProductId(productId: string, customerId: string): Observable<OrderRow[]> {
    const url = `json/order-services/find-orders/${productId}/${customerId}`;
    return this.http.get<OrderRow[]>(url);
  }

  public findOrdersContainingSerialNr(serialNumber: string, customerId: string): Observable<OrderRow[]> {
    const url = `json/order-services/find-orders-by-serial/${serialNumber}/${customerId}`;
    return this.http.get<OrderRow[]>(url);
  }

  public sendEmailWithAttestLink(recipientEmail: string, orderId: string, status: string, productId: string, username: string): Observable<any> {
    const warrantyUrl = window.location.href;
    const url = `json/order-services/send-email`;
    return this.http.post<any>(url, { warrantyUrl: warrantyUrl, orderId: orderId, productId: productId, recipientEmail: recipientEmail, status: status, userName: username });
  }

  public findNumberOfOrderServicesTicketsForCustomer(customerId: string): Observable<number> {
    const url = `json/order-services/count/${customerId}`;
    const headers = {
      maxAge: '-1'
    };
    return this.http.get<number>(url, { headers });
  }

  public findOrderServicesTicketById(ticketId: string): Observable<OrderServicesTicket> {
    const url = `json/order-services/${ticketId}`;
    return this.http.get<OrderServicesTicket>(url);
  }

}
